import { TranslationContext } from './TranslationContext'

export default TranslationContext
